import { render, staticRenderFns } from "./organizeTree.vue?vue&type=template&id=0009574d&scoped=true&"
import script from "./organizeTree.vue?vue&type=script&lang=js&"
export * from "./organizeTree.vue?vue&type=script&lang=js&"
import style0 from "./organizeTree.vue?vue&type=style&index=0&id=0009574d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0009574d",
  null
  
)

export default component.exports